var _defs, _circle, _ellipse, _ellipse2, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMellowPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:url(#D\xE9grad\xE9_sans_nom);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke-width:0px;}.cls-2{fill:#f3f3f3;}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_4);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_2);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_3);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom",
    cx: -846.85,
    cy: 602.95,
    fx: -846.85,
    fy: 602.95,
    r: 1,
    gradientTransform: "translate(-24680 34762) rotate(90) scale(41 -41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e122b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#131d52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2750aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#a3eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_2",
    cx: -844.49,
    cy: 607.08,
    fx: -844.49,
    fy: 607.08,
    r: 1,
    gradientTransform: "translate(-20747.08 29019.82) rotate(90) scale(34.32 -34.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f85f97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#330e18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f00a38"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_3",
    cx: -839.54,
    cy: 615.48,
    fx: -839.54,
    fy: 615.48,
    r: 1,
    gradientTransform: "translate(-15750.96 21527.56) rotate(90) scale(25.59 -25.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#23164b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#15105d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2d68c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4",
    cx: -821.93,
    cy: 645.95,
    fx: -821.93,
    fy: 645.95,
    r: 1,
    gradientTransform: "translate(-8646.12 11082.18) rotate(90) scale(13.43 -13.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb2354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ce2c65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff94ce"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41,
    cy: 41,
    r: 41
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 46.35,
    cy: 41.06,
    rx: 34.25,
    ry: 34.32
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 40.3,
    cy: 41,
    rx: 25.66,
    ry: 25.59
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 31,
    cy: 41.06,
    r: 13.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMellowPoints);
export default __webpack_public_path__ + "static/media/mellowPoints.bebfba0684f26411a46f247683ada88b.svg";
export { ForwardRef as ReactComponent };